import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentSharedModule } from '@app/content/shared/content-shared.module';
import { TermsAndConditionRoutingModule } from '@app/my-zone/pages/terms-and-conditions/terms-and-condition-routing.module';
import { TermsAndConditionsComponent } from '@app/my-zone/pages/terms-and-conditions/terms-and-conditions.component';
import { TermsAndConditionContainer } from '@app/my-zone/pages/terms-and-conditions/terms-and-conditions.container';
import { PdfLinkModule } from '@app/shared/pdf-link/pdf-link.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { TermsAndConditionsProductsComponent } from './terms-and-condition-products/terms-and-conditions-products.component';

@NgModule({
    declarations: [TermsAndConditionsComponent, TermsAndConditionContainer, TermsAndConditionsProductsComponent],
    imports: [
        CommonModule,
        TermsAndConditionRoutingModule,
        ListModule,
        ContentSharedModule,
        PdfLinkModule,
    ],
})
export class TermsAndConditionsModule {}
